import SimpleCrudForm from "../../components/crud/SimpleCrudForm";

export default function TripIssueForm() {
  return (
    <SimpleCrudForm
      title="Trip Issue"
      apiPath="/trip-issues"
      listRoute="/trip-issues"
      initialData={{
        bookingId: "",
        issueType: "delay",
        description: "",
        status: "open",
        priority: "medium",
        resolution: "",
      }}
      fields={[
        { name: "bookingId", label: "Booking Reference (number or UUID)", required: false },
        { name: "issueType", label: "Issue Type", type: "select", required: true, options: [
          { value: "delay", label: "Delay" },
          { value: "cancellation", label: "Cancellation" },
          { value: "payment", label: "Payment" },
          { value: "driver", label: "Driver" },
          { value: "other", label: "Other" },
        ]},
        { name: "description", label: "Description", type: "textarea", required: true },
        { name: "status", label: "Status", type: "select", options: [
          { value: "open", label: "Open" },
          { value: "resolved", label: "Resolved" },
          { value: "closed", label: "Closed" },
        ]},
        { name: "priority", label: "Priority", type: "select", options: [
          { value: "low", label: "Low" },
          { value: "medium", label: "Medium" },
          { value: "high", label: "High" },
        ]},
        { name: "resolution", label: "Resolution", type: "textarea" },
      ]}
    />
  );
}
